import { handleActions } from "redux-actions";
import reducerMap from "./reducerMap";
import defaultState from "./defaultState";
import isBackInStockNotificationEnabled from "../isBackInStockEnabled";

export default isBackInStockNotificationEnabled()
  ? handleActions(reducerMap, defaultState)
  : undefined;
